export enum AddressType {
  CustomerAddress,
  ServiceAddress,
}
